import { ConverterSet, ConverterType } from '../domain.js';

export const float: ConverterSet = {
  types: [
    'FLOAT',
    'DOUBLE',
    'google.protobuf.FloatValue',
    'google.protobuf.DoubleValue',
  ],

  [ConverterType.TO_JSON]: {
    transform: (val: number) => {
      return isFinite(val) ? val : val.toString();
    },
  },

  [ConverterType.FROM_JSON]: {
    transform: (val: string | number) => {
      if (val === 'NaN') {
        return NaN;
      }

      if (val === 'Infinity') {
        return Infinity;
      }

      if (val === '-Infinity') {
        return -Infinity;
      }

      return val;
    },
  },
};
